<!-- Page Header Start-->
<div class="page-header shadow-lg  bg-body rounded pl-5" [class.close_icon]="navServices.collapseSidebar">
  <div class="header-wrapper row m-0">
    <app-search></app-search>
    <div class="header-logo-wrapper">
      <div class="logo-wrapper">
        <a routerLink='/'>
          <img class="img-fluid for-light" src="http://mop.resmaxglobal.com/assets/images/logo.png" alt="">
          <img class="img-fluid for-dark" src="http://mop.resmaxglobal.com/assets/images/logo.png" alt="">
        </a>
      </div>
      <div class="toggle-sidebar" (click)="sidebarToggle()">
        <app-feather-icons  [icon]="'grid'" class="status_toggle middle"></app-feather-icons>
      </div>
     <div class="row">
      <!-- <p  class="h txt-primary">VMS</p> -->
      <div class="left-header col horizontal-wrapper pl-0 pt-2">
       <h3>Visitors Management System</h3>
      </div>
     </div>
    </div>
    <div class="left-header col horizontal-wrapper pl-0">
     
    </div>
    <div class="nav-right col-8 pull-right right-header p-0">
      <ul class="nav-menus">
        <!-- <li class="language-nav" (click)="languageToggle()">
          <app-languages></app-languages>
        </li> -->
        <li >
          <span class="header-search" (click)="searchToggle()">
            <app-feather-icons  [icon]="'search'"></app-feather-icons>
          </span>
        </li>
          
        <li class="onhover-dropdown">
          <app-bookmark></app-bookmark>
        </li>
        <li>
          <div class="mode" (click)="layoutToggle()">
            <i class="fa fa-moon-o" *ngIf="!dark"></i>
            <i class="fa fa-lightbulb-o" *ngIf="dark"></i>
          </div>
        </li>
        
        <li class="maximize">
          <a class="text-dark" href="javascript:void(0)" (click)="toggleFullScreen()">
            <app-feather-icons [icon]="'maximize'"></app-feather-icons>
          </a>
        </li>
        <li class="profile-nav onhover-dropdown p-0">
           <app-my-account></app-my-account>
        </li>
      
      </ul>
    </div>
  </div>
</div>
<!-- Page Header Ends -->